import {messageIndex,homeChannel1,homeChannel2,homeChannel3,homeChannel4,homeChannel5,helpList,helpDetail,configIndex,configCompany,projectTenderType,projectTenderIndex,projectTenderDetail,projectLawIndex,projectLawDetail,projectBidType,projectBidIndex,projectBidDetail,projectDownloadType,projectDownloadIndex,serviceIndex,projectBusinessDetail,projectProcessDetail,homeSearch,sliderData,messageDetail} from "../../../api/main/index";
let modules = {
	namespaced: true,
	state: {


	},
	mutations: {
		
	},
	actions: {
    //配置
    getConfigIndex(conText, payload) {
			configIndex(payload.data, payload.headers).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
    //关于我们
    getConfigCompany(conText, payload) {
    	configCompany(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
		//通知公告
		getMessageIndex(conText, payload) {
			messageIndex(payload.data, payload.headers).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
    //招标公告
    getHomeChannel1(conText, payload) {
      homeChannel1(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //中标公告
    getHomeChannel2(conText, payload) {
      homeChannel2(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
		//更正公告
		getHomeChannel3(conText, payload) {
		  homeChannel3(payload.data, payload.headers).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
    //下载中心
    getHomeChannel4(conText, payload) {
      homeChannel4(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //电子竞价平台栏目
    getHomeChannel5(conText, payload) {
      homeChannel5(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //帮助中心列表
    getHelpList(conText, payload) {
      helpList(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //帮助中心详情
    getHelpDetail(conText, payload) {
      helpDetail(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //招标专区类型
    getProjectTenderType(conText, payload) {
      projectTenderType(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //招标专区列表
    getProjectTenderIndex(conText, payload) {
      projectTenderIndex(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //招标专区详情
    getProjectTenderDetail(conText, payload) {
      projectTenderDetail(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //法律法规列表
    getProjectLawIndex(conText, payload) {
      projectLawIndex(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //法律法规详情
    getProjectLawDetail(conText, payload) {
      projectLawDetail(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    
    
    //招标专区类型
    getProjectBidType(conText, payload) {
      projectBidType(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //招标专区列表
    getProjectBidIndex(conText, payload) {
      projectBidIndex(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //招标专区详情
    getProjectBidDetail(conText, payload) {
      projectBidDetail(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    
    //招标专区类型
    getProjectDownloadType(conText, payload) {
      projectDownloadType(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //招标专区列表
    getProjectDownloadIndex(conText, payload) {
      projectDownloadIndex(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    
    //服务栏目
    getServiceIndex(conText, payload) {
      serviceIndex(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //业务范围
    getProjectBusinessDetail(conText, payload) {
      projectBusinessDetail(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //业务流程
    getProjectProcessDetail(conText, payload) {
      projectProcessDetail(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
    //首页搜索
    getHomeSearch(conText, payload) {
      homeSearch(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
		//友情链接
		getSliderData(conText, payload){
			sliderData(payload.data, payload.headers).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
    //通知详情
    getMessageDetail(conText, payload){
    	messageDetail(payload.data, payload.headers).then(res => {
    		if (payload.success) {
    			payload.success(res)
    		}
    	})
    },
	}

}
export default modules;
